import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconAssociate from '@/icons/Associate.svg';

import { useFilters } from '../FiltersState';

export const FiltersEntity = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    entities: { entities, setEntities },
  } = useFilters();

  const selectedCount = entities.length;

  return (
    <DesktopEntityFilter
      selectedEntities={entities}
      setSelectedEntities={setEntities}
      includeGroups={false}
      tag={tag}
      label={t({
        id: 'settings.organization.members.users.filters.entity.label',
        message: 'Entity',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.members.users.filters.entity.search',
        message: 'Search entities',
      })}
      icon={<IconAssociate />}
      tagSelectedCountLabel={i18n._({
        id: 'settings.organization.members.users.filters.entity.multiple',
        message: '{selectedCount} selected',
        values: { selectedCount },
      })}
    />
  );
};
